import { useContext, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { FeedbackBtnClickTrackerContext } from '../contexts/Tracking';
import { trackGiveFeedbackButtonClick } from '../../app/utils/tracking';
import BetaFeedbackModal from './BetaFeedbackModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FeedbackButton = ({
  size,
  use,
  rolloutId,
  productUpdateId,
  productUpdateTitle,
  lastSubmittedDate
}) => {
  const {
    screen,
    subscreen,
    origin,
    rolloutState
  } = useContext(FeedbackBtnClickTrackerContext);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      use,
      size,
      block: true,
      onClick: () => {
        setShowFeedbackModal(true);
        if (subscreen && origin) {
          trackGiveFeedbackButtonClick({
            screen,
            subscreen,
            origin,
            rolloutState,
            productUpdateId: `${productUpdateId}`,
            productUpdateTitle
          });
        }
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.detailsPanel.giveFeedback"
      })
    }), showFeedbackModal && /*#__PURE__*/_jsx(BetaFeedbackModal, {
      rolloutId: rolloutId,
      productUpdateId: productUpdateId,
      productUpdateTitle: productUpdateTitle,
      lastSubmittedDate: lastSubmittedDate,
      onClose: () => {
        setShowFeedbackModal(false);
      }
    })]
  });
};
export default FeedbackButton;